import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeOneComponent } from './components/pages/home-one/home-one.component';
import { AboutComponent } from './components/pages/about/about.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { VideoListComponent } from './components/pages/video-list/video-list.component';
import { ProductDetailsComponent } from './components/pages/product-details/product-details.component';
import { TeamDetailsComponent } from './components/pages/team-details/team-details.component';
import { CareerComponent } from './components/pages/career/career.component';
import { NewsComponent } from './components/pages/news/news.component';
import { NewsDetailsComponent } from './components/pages/news-details/news-details.component';
import { PrivacyComponent } from './components/pages/privacy/privacy.component';
import { TermsComponent } from './components/pages/terms/terms.component';
import { ProductListComponent } from './components/pages/product-list/product-list.component';
import { ClientListComponent } from './components/pages/client-list/client-list.component';
import { CustomerSatisfactionComponent } from './components/pages/customer-satisfaction/customer-satisfaction.component';
import { CustomerTestimonialComponent } from './components/pages/customer-testimonial/customer-testimonial.component';

const routes: Routes = [
    {path: '', component: HomeOneComponent},
    {path: 'about-us', component: AboutComponent},
    {path: 'team-details/:teamId', component: TeamDetailsComponent},
    {path: 'videos', component: VideoListComponent},
    {path: 'product/:type', component: ProductListComponent},
    {path: 'product-details/:productType/:productId', component: ProductDetailsComponent},
    {path: 'contact-us', component: ContactComponent},
    {path: 'career', component: CareerComponent},
    {path: 'news', component: NewsComponent},
    {path: 'news-details/:newsId', component: NewsDetailsComponent},
    {path: 'privacy', component: PrivacyComponent},
    {path: 'terms', component: TermsComponent},
    {path: 'clients', component: ClientListComponent},
    {path: 'satisfaction', component: CustomerSatisfactionComponent},
    {path: 'testimonial', component: CustomerTestimonialComponent},
    { path: '', redirectTo: '/', pathMatch: 'full' },
    { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }
